import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {filterHeadline, filterHTML, filterResource} from "../../helpers/filters";

interface Data {
    paragraphById: {
        fieldTxtHeadline: string;
        fieldHtmlBody: Array<{
            value: string;
            format: string;
            processed: string;
        }>;
        fieldObjectImgMedia: Array<{
            entity: Array<{
                fieldMediaImage: Array<{
                    width: string;
                    height: string;
                    url: string;
                    targetId: string;
                    alt: string;
                    title: string;
                }>;
            }>;
        }>;
        fieldBackgroundColor: string;
        fieldTextAlignment: string;
        fieldTextColor: string;
    }
}

class InnerCardFeatureBoxQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphInnerCardFeatureBox2 {
          fieldTxtHeadline
          fieldHtmlBody {
            value
            format
            processed
          }
          fieldObjectImgMedia {
              entity {
                ... on MediaImage {
                  fieldMediaImage {
                    width
                    height
                    url
                    alt
                    title
                  }
                }
            }
          }

          fieldBackgroundColor
          fieldTextAlignment
          fieldTextColor
        }
      }
    }
  }
}
`;

const InnerCardFeatureBoxAlt = ({id, stylesObject, markComponentLoadedAs}) => (
    <InnerCardFeatureBoxQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            const imageBoxStyles = {};

            if (field.fieldObjectImgMedia && field.fieldObjectImgMedia.entity && field.fieldObjectImgMedia.entity.fieldMediaImage && field.fieldObjectImgMedia.entity.fieldMediaImage.url) {
                imageBoxStyles.background = `url('${filterResource(field.fieldObjectImgMedia.entity.fieldMediaImage.url)}') no-repeat center center`;
                imageBoxStyles.backgroundSize = 'cover';
            }

            let outerStyles = {};
            if (field.fieldBackgroundColor) {
                outerStyles.backgroundColor = field.fieldBackgroundColor;
            }
            if (field.fieldTextAlignment) {
                outerStyles.textAlign = field.fieldTextAlignment;
            }
            if (field.fieldTextColor) {
                outerStyles.color = field.fieldTextColor;
            }

            // Merge outerStyles and styles inherited from parent
            outerStyles = {...outerStyles, ...stylesObject};

            markComponentLoadedAs(id, true);

            const backgroundColorSet = Object.keys(outerStyles).includes('backgroundColor') ? !['#FFF', '#FFFFFF', '#fff', '#ffffff'].includes(outerStyles.backgroundColor) : false;

            return (
                <div className={`innerCardFeatureBox innerCardFeatureBoxAlt innerCardFeatureBox--${outerStyles.textAlign} innerCardFeatureBox--${backgroundColorSet ? 'withBg' : 'withoutBg'}`} style={outerStyles}>

                    <div className="innercardFeatureBox__front">
                        {!field.fieldImageBelowContent && field.fieldObjectImgMedia && field.fieldObjectImgMedia.entity && field.fieldObjectImgMedia.entity.fieldMediaImage && field.fieldObjectImgMedia.entity.fieldMediaImage.url && (
                            <div className="innerCardFeatureBox__imageModule" style={imageBoxStyles}/> 
                        )}

                        <div className="innerCardFeatureBox__textModule">


                            {field.fieldTxtHeadline && (
                                // eslint-disable-next-line react/no-danger
                                <h3 className="innerCardFeatureBox__title" dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtHeadline)}} />
                            )}

                            <button className="innerCardFeatureBoxAlt__cta text-cta" onClick={(e) => {
                                e.target.parentElement.parentElement.parentElement.classList.toggle('open');
                            }}>See Details</button>
                        </div>
                    </div>


                    <div className="innerCardFeatureBoxAlt__bodyModule">
                        {field.fieldHtmlBody && field.fieldHtmlBody.processed && (
                            // eslint-disable-next-line react/no-danger
                            <div className="innerCardFeatureBox__body" dangerouslySetInnerHTML={{__html: filterHTML(field.fieldHtmlBody.processed)}}/>
                        )}

                        <button className="innerCardFeatureBoxAlt__cta" onClick={(e) => {
                            e.target.parentElement.parentElement.classList.toggle('open');
                        }}>Close</button>
                    </div>

                    {field.fieldImageBelowContent && field.fieldObjectImgMedia && field.fieldObjectImgMedia.entity && field.fieldObjectImgMedia.entity.fieldMediaImage && field.fieldObjectImgMedia.entity.fieldMediaImage.url && (
                        <React.Fragment>
                            {field.fieldInlineImage ? (
                                <img className="innerCardFeatureBox__imageModuleInline"
                                     src={field.fieldObjectImgMedia.entity.fieldMediaImage.url}
                                     alt={field.fieldObjectImgMedia.entity.fieldMediaImage.alt}/>

                            ) : (
                                <div className="innerCardFeatureBox__imageModule" style={imageBoxStyles}/>
                            )}
                        </React.Fragment>
                    )}


                </div>
            );
        }}
    </InnerCardFeatureBoxQuery>
);

InnerCardFeatureBoxAlt.propTypes = {
    id: PropTypes.number.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    stylesObject: PropTypes.object,
    markComponentLoadedAs: PropTypes.func.isRequired,
};

InnerCardFeatureBoxAlt.defaultProps = {
    stylesObject: {}
};


export default InnerCardFeatureBoxAlt;



// WEBPACK FOOTER //
// ./frontend/components/FeaturedCards2021/InnerCardFeatureBoxAlt.jsx